import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Row,
  Col,
  Typography,
  Card,
  Image,
  Checkbox,
  Badge,
  Divider,
  List,
  Collapse,
  Input,
  Slider,
  Select
} from 'antd';
import FileListGrid from '../Upload/FileListGrid';
import axios from 'axios';
import { queries } from '../../graphql/graphql';
import { useQuery } from '@apollo/react-hooks';
import { v4 as uuidv4 } from 'uuid';

const { Title, Text } = Typography;
const { Meta } = Card;
const { Panel } = Collapse;

const stylesList = [
  {
    value: 'white_painted',
    text: 'White Painted',
    img: 'https://via.placeholder.com/150/FFFFFF?text=White+Painted'
  },
  {
    value: 'white_wood',
    text: 'White Wood Siding',
    img: 'https://via.placeholder.com/150/FFFFFF?text=White+Wood+Siding'
  },
  {
    value: 'combined_white_wood',
    text: 'Combined White Painted and Natural Wooden Siding',
    img: 'https://via.placeholder.com/150/FFFFFF?text=Combined+White+and+Wood'
  },
  {
    value: 'yellow_wood',
    text: 'Yellow Nature Wood Siding',
    img: 'https://via.placeholder.com/150/FFFF99?text=Yellow+Wood+Siding'
  },
  {
    value: 'blue_wood',
    text: 'Light Blue Wood Siding',
    img: 'https://via.placeholder.com/150/ADD8E6?text=Blue+Wood+Siding'
  },
  {
    value: 'green_wood',
    text: 'Light Green Wood Siding',
    img: 'https://via.placeholder.com/150/90EE90?text=Green+Wood+Siding'
  },
  {
    value: 'hip_roof',
    text: 'Hip Roof',
    img: 'https://via.placeholder.com/150/FFA07A?text=Hip+Roof'
  },
  {
    value: 'gable_roof',
    text: 'Gable Roof',
    img: 'https://via.placeholder.com/150/FFA07A?text=Gable+Roof'
  },
  {
    value: 'flat_roof',
    text: 'Flat Roof',
    img: 'https://via.placeholder.com/150/808080?text=Flat+Roof'
  },
  {
    value: 'has_garage',
    text: 'Has garage',
    img: ''
  }
];

export const FluxGenerationsView = ({ items = [], onAdd }) => {
  const pendingTime = items => {
    let time = 0;
    for (const item of items) {
      if (item.status !== 'done') {
        try {
          time += Number(item.data.settings.steps * item.data.results.length);
        } catch (error) {
          console.error(error);
        }
      }
    }
    return Math.ceil(time / 60);
  };

  return (
    <Row gutter={[16, 16]} style={{ width: '100%' }}>
      <Col span={24}>
        {items.length && (
          <Text>
            Done: {items.filter(item => item.status === 'done').length}; Execution time:{' '}
            {Number(items.reduce((acc, item) => acc + +item.executionTime, 0) / 60 / 60).toFixed(1)}
            h
            <br />
          </Text>
        )}
        {items.length && (
          <Text>
            Pending: {items.filter(item => item.status !== 'done').length}; Remainig:{' '}
            {pendingTime(items)}m
          </Text>
        )}
      </Col>
      <List
        pagination={{
          pageSize: 20
        }}
        style={{ width: '100%' }}
        dataSource={items}
        renderItem={(generation, genIndex) => (
          <Col span={24} key={`gen-${genIndex}`}>
            <Badge.Ribbon
              text={generation.status}
              color={generation.status === 'done' ? 'green' : 'yellow'}
            >
              <Card style={{ width: '100%' }}>
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Card>
                      <Image style={{ maxWidth: '400px' }} src={generation.sourceImage} />
                      <Meta
                        title={`Execution time: ${generation.executionTime}s`}
                        description={
                          <div>
                            <p>Settings:</p>
                            <p>steps: {generation.data.settings.steps}</p>
                            <p>guidance: {generation.data.settings.guidance}</p>
                            <p>
                              control type:{' '}
                              {generation.data.settings.control_type === 2 ? 'depth' : 'canny'}
                            </p>
                            <p>control scale: {generation.data.settings.control_scale}</p>
                            <p>
                              control guidance start:{' '}
                              {generation.data.settings.control_guidance_start}
                            </p>
                            <p>
                              control guidance end: {generation.data.settings.control_guidance_end}
                            </p>
                          </div>
                        }
                      />
                    </Card>
                  </Col>
                  <Col span={24}>
                    <Collapse>
                      <Panel
                        header={`Results [${generation.data.results.length}]`}
                        disabled={generation.status !== 'done'}
                      >
                        <Row gutter={[16, 16]}>
                          {generation.data.results.map((result, resIndex) => (
                            <Col span={24} key={`result-${resIndex}`}>
                              <List
                                itemLayout="vertical"
                                size="large"
                                dataSource={result.images}
                                renderItem={(item, index) => (
                                  <List.Item key={index} actions={[onAdd]}>
                                    <Row gutter={[0, 16]}>
                                      <Col span={12}>
                                        <Image alt="logo" src={generation.sourceImage} />
                                      </Col>
                                      <Col span={12}>
                                        <Image alt="logo" src={item} />
                                      </Col>
                                      <Col span={24}>
                                        <Text>Propmt: </Text>
                                        <Text type="secondary">
                                          {result.prompt}
                                          <br />
                                        </Text>
                                        <Text>Styles: </Text>
                                        <Text type="secondary">
                                          {result.styles.join(', ')}
                                          <br />
                                        </Text>
                                      </Col>
                                      {onAdd && (
                                        <Col span={24}>
                                          <Button
                                            type="primary"
                                            onClick={() => onAdd(item)}
                                            key="preview"
                                          >
                                            Add
                                          </Button>
                                        </Col>
                                      )}
                                    </Row>
                                  </List.Item>
                                )}
                              />
                              <Divider />
                            </Col>
                          ))}
                        </Row>
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
              </Card>
            </Badge.Ribbon>
          </Col>
        )}
      />
      {/* {items.map((generation, genIndex) => (
        <Col span={24} key={`gen-${genIndex}`}>
          <Badge.Ribbon
            text={generation.status}
            color={generation.status === 'done' ? 'green' : 'yellow'}
          >
            <Card style={{ width: '100%' }}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Card>
                    <Image style={{ maxWidth: '400px' }} src={generation.sourceImage} />
                    <Meta
                      title={`Execution time: ${generation.executionTime}s`}
                      description={
                        <div>
                          <p>Settings:</p>
                          <p>steps: {generation.data.settings.steps}</p>
                          <p>guidance: {generation.data.settings.guidance}</p>
                          <p>
                            control type:{' '}
                            {generation.data.settings.control_type === 2 ? 'depth' : 'canny'}
                          </p>
                          <p>control scale: {generation.data.settings.control_scale}</p>
                          <p>
                            control guidance start:{' '}
                            {generation.data.settings.control_guidance_start}
                          </p>
                          <p>
                            control guidance end: {generation.data.settings.control_guidance_end}
                          </p>
                        </div>
                      }
                    />
                  </Card>
                </Col>
                <Col span={24}>
                  <Collapse>
                    <Panel
                      header={`Results [${generation.data.results.length}]`}
                      disabled={generation.status !== 'done'}
                    >
                      <Row gutter={[16, 16]}>
                        {generation.data.results.map((result, resIndex) => (
                          <Col span={24} key={`result-${resIndex}`}>
                            <List
                              itemLayout="vertical"
                              size="large"
                              dataSource={result.images}
                              renderItem={(item, index) => (
                                <List.Item key={index} actions={[onAdd]}>
                                  <Row gutter={[0, 16]}>
                                    <Col span={12}>
                                      <Image alt="logo" src={generation.sourceImage} />
                                    </Col>
                                    <Col span={12}>
                                      <Image alt="logo" src={item} />
                                    </Col>
                                    <Col span={24}>
                                      <Text>Propmt: </Text>
                                      <Text type="secondary">
                                        {result.prompt}
                                        <br />
                                      </Text>
                                      <Text>Styles: </Text>
                                      <Text type="secondary">
                                        {result.styles.join(', ')}
                                        <br />
                                      </Text>
                                    </Col>
                                    {onAdd && (
                                      <Col span={24}>
                                        <Button
                                          type="primary"
                                          onClick={() => onAdd(item)}
                                          key="preview"
                                        >
                                          Add
                                        </Button>
                                      </Col>
                                    )}
                                  </Row>
                                </List.Item>
                              )}
                            />
                            <Divider />
                          </Col>
                        ))}
                      </Row>
                    </Panel>
                  </Collapse>
                </Col>
              </Row>
            </Card>
          </Badge.Ribbon>
        </Col>
      ))} */}
    </Row>
  );
};

export const FluxGenerationsList = props => {
  const { data = {}, loading } = useQuery(queries.FLUX_GENERATIONS, {
    variables: {}
  });
  const { fluxGenerations } = data;

  if (loading) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  if (!fluxGenerations) {
    return <Typography.Text>Oops...</Typography.Text>;
  }

  return <FluxGenerationsView items={fluxGenerations} />;
};

export const FluxGenerations = props => {
  const { id, onAdd, loadingGenerate } = props;

  const { data = {}, refetch, loading } = useQuery(queries.FLUX_GENERATIONS_BY_PLAN_ID, {
    variables: { planId: id }
  });
  const { fluxGenerationByPlanId } = data;

  useEffect(() => {
    refetch();
  }, [loadingGenerate]);
  if (loading) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  if (!fluxGenerationByPlanId) {
    return <Typography.Text>Oops...</Typography.Text>;
  }

  return <FluxGenerationsView items={fluxGenerationByPlanId} onAdd={onAdd} />;
};

export const FluxExterior = props => {
  const { photos, planId, setPhotos } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [controlnetImage, setControlnetImage] = useState({});
  const [styles, setStyles] = useState([
    'blue_wood',
    'white_painted',
    'white_wood',
    'green_wood',
    'combined_white_wood',
    'yellow_wood',
    'hip_roof'
  ]);
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [steps, setSteps] = useState(28);
  const [controlScale, setControlScale] = useState(0.6);
  const [controlType, setControlType] = useState(2);
  const [guidance, setGuidance] = useState(3.5);
  const [controlGuidanceStart, setControlGuidanceStart] = useState(0.0);
  const [controlGuidanceEnd, setControlGuidanceEnd] = useState(0.6);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAdd = file => {
    setControlnetImage(file);
  };

  const handleStyleToggle = style => {
    setStyles(prevStyles =>
      prevStyles.includes(style) ? prevStyles.filter(s => s !== style) : [...prevStyles, style]
    );
  };

  const getPhotoAction = file => {
    const actions = [
      <Button type="primary" onClick={() => onAdd(file)} key="preview">
        Select
      </Button>
    ];
    return actions;
  };

  const onGenerate = async e => {
    e.preventDefault();
    setLoadingGenerate(true);
    const data = {
      styles,
      image: controlnetImage.url,
      planId,
      settings: {
        steps: +steps,
        control_scale: +controlScale,
        control_type: +controlType,
        guidance: +guidance,
        control_guidance_start: +controlGuidanceStart,
        control_guidance_end: +controlGuidanceEnd
      }
    };
    console.log(data);

    try {
      const response = await axios({
        method: 'post',
        url: '/api/flux/generate-images',
        data
      });
      console.debug(response);
      setLoadingGenerate(false);
    } catch (error) {
      console.error(error);
      setLoadingGenerate(false);
    }
  };

  const onAddPhoto = url => {
    const newList = [].concat(photos);
    newList.push({
      uid: uuidv4(),
      url: url,
      status: 'done',
      selected: false
    });
    setPhotos(newList);
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Flux exterior
      </Button>
      <Modal
        width={1000}
        title="Flux"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={4}>1. Select Exterior View Image (for ControlNet)</Title>
            <Text type="secondary">
              Choose an image for the exterior configuration. This will be used to generate a
              preview.
            </Text>
            <div style={{ marginTop: 16 }}>
              {photos && photos.length ? (
                <FileListGrid compact={true} fileList={photos} customActions={getPhotoAction} />
              ) : (
                <Text>No photos available.</Text>
              )}
            </div>
          </Col>
          {controlnetImage.url && (
            <Col span={24}>
              <Title level={4}>2. Configure Details</Title>
              <Card
                hoverable={true}
                bordered={true}
                bodyStyle={{ padding: 0, margin: 0 }}
                cover={
                  <Image
                    src={controlnetImage.url || URL.createObjectURL(controlnetImage.originFileObj)}
                  />
                }
              />
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col span={24}>
                  <Text>Steps {steps}</Text>
                  <Slider
                    min={20}
                    max={50}
                    defaultValue={28}
                    value={steps}
                    name="steps"
                    onChange={setSteps}
                  />
                </Col>
                <Col span={24}>
                  <Text>Guidance</Text>
                  <Input
                    type="number"
                    min={1}
                    max={10}
                    defaultValue={3.5}
                    step={0.1}
                    value={guidance}
                    onChange={e => setGuidance(e.target.value)}
                  />
                </Col>
                <Col span={24}>
                  <Text>ControlNet Type </Text>
                  <Select value={controlType} onChange={setControlType}>
                    <Select.Option value={2}>Depth</Select.Option>
                    <Select.Option value={0}>Canny</Select.Option>
                  </Select>
                </Col>
                <Col span={24}>
                  <Text>Control scale</Text>
                  <Input
                    type="number"
                    min={0}
                    max={1}
                    defaultValue={0.6}
                    step={0.01}
                    value={controlScale}
                    onChange={e => setControlScale(e.target.value)}
                  />
                </Col>
                <Col span={24}>
                  <Text>Control guidance start</Text>
                  <Input
                    type="number"
                    min={0}
                    max={1}
                    defaultValue={0.0}
                    step={0.01}
                    value={controlGuidanceStart}
                    onChange={e => setControlGuidanceStart(e.target.value)}
                  />
                </Col>
                <Col span={24}>
                  <Text>Control guidance end</Text>
                  <Input
                    type="number"
                    min={0}
                    max={1}
                    defaultValue={0.0}
                    step={0.01}
                    value={controlGuidanceEnd}
                    onChange={e => setControlGuidanceEnd(e.target.value)}
                  />
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                {stylesList.map(({ value, img, text }) => (
                  <Col span={6} key={value}>
                    <Card
                      hoverable
                      style={{
                        textAlign: 'center',
                        border: styles.includes(value) ? '2px solid #1890ff' : '1px solid #d9d9d9'
                      }}
                      onClick={() => handleStyleToggle(value)}
                    >
                      <Checkbox
                        checked={styles.includes(value)}
                        onChange={() => handleStyleToggle(value)}
                      >
                        {text}
                      </Checkbox>
                    </Card>
                  </Col>
                ))}
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Button type="primary" onClick={onGenerate} loading={loadingGenerate}>
                  Generate
                </Button>
              </Row>
            </Col>
          )}
          <FluxGenerations loadingGenerate={loadingGenerate} id={planId} onAdd={onAddPhoto} />
        </Row>
      </Modal>
    </>
  );
};
